import { render, staticRenderFns } from "./BulkImportIngredientsView.vue?vue&type=template&id=36ccdc94&scoped=true"
import script from "./BulkImportIngredientsView.vue?vue&type=script&lang=js"
export * from "./BulkImportIngredientsView.vue?vue&type=script&lang=js"
import style0 from "./BulkImportIngredientsView.vue?vue&type=style&index=0&id=36ccdc94&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36ccdc94",
  null
  
)

export default component.exports